import { RequireAuth } from '@auth/require-auth'
import { RequireBillPay } from '@auth/require-bill-pay'
import { SmartRedirect } from '@auth/smart-redirect'
import { InnerLayout } from '@components/inner-layout'
import {
  AGENT_BILL_PAY_PATH,
  getAgentBillPayBatchPath,
  getAgentBillPayBatchSubmissionPreviewPath,
} from '@pages/bill-pay/constants'
import { BillPayUnavailable } from '@pages/bill-pay-unavailable'
import { SignIn } from '@pages/sign-in'
import { Routes, Route } from 'react-router-dom'

import { AskAiRoute } from './ask-ai-route'
import { BillPayRoute } from './bill-pay-route'
import { DocumentRoute } from './document-route'
import { DocumentsRoute } from './documents-route'
import { PaymentBatchRoute } from './payment-batch-route'
import { PaymentSubmissionPreviewRoute } from './payment-submission-preview-route'

export const StandaloneRoutes = () => (
  <Routes>
    <Route path="/signin" Component={SignIn} />
    <Route
      element={
        <RequireAuth>
          <InnerLayout />
        </RequireAuth>
      }
    >
      <Route index Component={DocumentsRoute} />
      <Route path="/" Component={DocumentsRoute} />
      <Route path="/ask-ai" Component={AskAiRoute} />
      <Route
        path={AGENT_BILL_PAY_PATH}
        element={
          <RequireBillPay fallback={<BillPayUnavailable />}>
            <BillPayRoute />
          </RequireBillPay>
        }
      />
      <Route
        path={getAgentBillPayBatchPath(':batchId')}
        element={
          <RequireBillPay fallback={<BillPayUnavailable />}>
            <PaymentBatchRoute />
          </RequireBillPay>
        }
      />
      <Route
        path={getAgentBillPayBatchSubmissionPreviewPath(':batchId')}
        element={
          <RequireBillPay fallback={<BillPayUnavailable />}>
            <PaymentSubmissionPreviewRoute />
          </RequireBillPay>
        }
      />
      <Route path="/ask-ai/:chatId" Component={AskAiRoute} />
      <Route path="/document/:docId" Component={DocumentRoute} />
    </Route>
    <Route path="*" element={<SmartRedirect isInIframe={false} />} />
  </Routes>
)
